@charset "UTF-8";

/* src/app/components/shared/components/header/header.component.scss */
header {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(247, 247, 247);
  border-bottom: 1px solid rgb(220, 220, 222);
  color: #474747;
  font-weight: 800;
  position: relative;
}
header .container-width {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  width: 100%;
  padding: 0 15px 0 0;
  box-sizing: border-box;
  position: relative;
}
header .header-left {
  display: flex;
  align-items: center;
}
header .header-left .logo {
  height: 30px;
  width: auto;
  margin-left: 13px;
}
header .header-left .logo:hover {
  cursor: pointer;
}
header .header-middle {
  position: absolute;
  left: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 1000;
}
.sidebar-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.header-right {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
.dropdown-wrapper {
  position: relative;
}
.extra-width {
  width: 300px;
}
.dropdown-btn {
  color: white;
  gap: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  border: none;
}
.dropdown-btn:hover {
  background-color: #f8fcfc;
  transform: translateX(4px);
  transition: all 0.2s ease;
  color: #00A4A4;
  width: 90%;
}
.dropdown-btn:hover .fa-page-icon {
  filter: invert(54%) sepia(91%) saturate(486%) hue-rotate(140deg) brightness(92%) contrast(101%);
}
.dropdown-btn .fa-page-icon {
  height: 16px;
  width: auto;
  filter: invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(100%) !important;
}
.logout-btn:hover {
  background-color: #a40c0c;
  transform: translateX(4px);
  transition: all 0.2s ease;
  color: white;
}
.button-group {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.fa-page-icon {
  height: 16px;
  width: auto;
  filter: invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(100%) !important;
}
.notification-btn {
  position: relative;
}
.notification-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 10px;
  height: 10px;
  background-color: #e53935;
  border-radius: 50%;
  border: 2px solid white;
}
.search-input-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 800px;
  background-color: rgb(247, 247, 247);
  border: none;
  border-radius: 6px !important;
}
.event-input {
  width: 600px;
  border-radius: 6px 0 0 6px !important;
  box-shadow: none;
  border-color: none;
  border-left: 1px solid lightgray !important;
  border-top: 1px solid lightgray !important;
  border-bottom: 1px solid lightgray !important;
  border-right: none !important;
}
.form-control {
  border-color: transparent;
}
.input-filter-btn {
  border-top: 1px solid lightgray !important;
  border-bottom: 1px solid lightgray !important;
  border-right: none;
  border-left: none;
}
.input-filter-btn:not(:disabled):hover {
  background-color: rgba(117, 119, 122, 0.5254901961);
  cursor: pointer;
}
.input-filter-btn:not(:disabled):hover .filter-svg {
  color: white;
}
.input-filter-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.input-search-btn {
  background-color: #007aff;
  border-top: 1px solid lightgray !important;
  border-bottom: 1px solid lightgray !important;
  border-right: 1px solid lightgray !important;
  border-left: none;
  border-radius: 0 6px 6px 0 !important;
}
.input-search-btn:not(:disabled):hover {
  background-color: rgba(0, 123, 255, 0.8352941176);
  cursor: pointer;
}
.input-search-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.input-info-btn {
  background-color: #007aff;
  border-top: 1px solid lightgray !important;
  border-bottom: 1px solid lightgray !important;
  border-right: none;
  border-left: 1px solid lightgray !important;
  border-radius: 6px 0 0 6px !important;
}
.resizable-event-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}
.resizable-event-container {
  background-color: rgb(247, 247, 247);
  border: 1px solid rgb(220, 220, 222);
  border-radius: 0 0 12px 12px;
  width: 1200px;
  min-height: 100px;
  max-height: 90vh;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0px 10px 10px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;
}
.event-scroll-wrapper {
  overflow-y: auto;
  height: calc(100% - 40px);
  overflow-x: hidden;
}
.resize-handle-vertical {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 6px;
  width: 100%;
  cursor: ns-resize;
  background: rgba(0, 0, 0, 0.1);
}
::ng-deep .event-list {
  height: 100% !important;
  max-height: unset !important;
  min-height: 100px !important;
  width: 100% !important;
  background-color: transparent !important;
}
mbsc-page {
  background-color: transparent;
}
.close-event-list-button-container,
.event-list-button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.filter-svg {
  color: #007aff;
}
.search-svg,
.info-svg {
  color: #ffffff;
}
.header-btn {
  background-color: transparent;
  border: none;
  border-bottom: 6px solid transparent;
  color: black;
  padding: 6px 12px;
  font-size: 16px;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.header-btn:hover {
  border-bottom-color: #00A4A4;
  color: #00A4A4;
  cursor: pointer;
  transform: translateY(-2px);
}
.header-btn:hover .fa-header-icon {
  filter: invert(54%) sepia(91%) saturate(486%) hue-rotate(140deg) brightness(92%) contrast(101%);
}
.header-btn.active {
  border-bottom-color: #00A4A4;
  color: #00A4A4;
  cursor: pointer;
  transform: translateY(-2px);
}
.header-btn.active .fa-header-icon {
  filter: invert(54%) sepia(91%) saturate(486%) hue-rotate(140deg) brightness(92%) contrast(101%);
}
.header-btn .fa-header-icon {
  height: 18px;
  width: auto;
  transition: filter 0.3s ease;
}
.split-divider {
  margin: 12px auto;
  width: calc(100% - 40px);
  height: 1px;
  background-color: #828281 !important;
  border-radius: 1px;
}
.user-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  width: 280px;
  gap: 10px;
}
.user-info img {
  height: 40px;
  width: 40px;
}
.user-icon {
  width: 32px;
  height: 32px;
  background-size: 200%;
  background-position: center 1%;
  background-repeat: no-repeat;
  border-radius: 50%;
}
.email-span {
  font-size: 14px;
  color: lightgrey;
}
.darkmode {
  border-color: #333333;
  background-color: #1c1c1c;
}
.darkmode .sidebar-btn {
  background-color: #1c1c1c;
}
.darkmode .search-input-container {
  background-color: #1c1c1c;
}
.darkmode .event-input {
  background-color: rgb(28, 28, 28);
  border: 1px solid #ff9f0a;
  color: #ff9f0a;
}
.darkmode .event-input::placeholder {
  color: #ff9f0a;
}
.darkmode .split-divider {
  background-color: #ff9f0a !important;
}
.darkmode .dropdown-btn:hover {
  background-color: #ff9f0a;
  color: rgb(0, 0, 0);
}
.darkmode .logout-btn:hover {
  background-color: #a40c0c;
}
.darkmode .header-btn {
  color: #ff9f0a !important;
}
.darkmode .header-btn:hover {
  border-bottom-color: #ff9f0a;
}
.darkmode .header-btn:active {
  border-bottom-color: #ff9f0a;
  color: #ff9f0a;
  cursor: pointer;
  transform: translateY(-2px);
}
.darkmodeDropdown {
  border-color: #ffa719;
  background-color: #1c1c1c;
}
.darkmode .input-search-btn {
  border-left: none !important;
}
.darkmode .input-search-btn:hover {
  background-color: rgba(255, 157, 10, 0.5960784314) !important;
}
.darkmode .input-filter-btn {
  border: 1px solid #ffffff;
}
.darkmode .input-filter-btn:hover {
  background-color: rgba(255, 157, 10, 0.5960784314) !important;
}
.darkmode .input-filter-btn .filter-svg {
  color: #ff9f0a;
}
.notification-badge {
  margin-top: 3px;
}
::ng-deep .darkmode .resizable-event-container {
  background-color: rgb(28, 28, 28);
  border: 1px solid #333333;
}
.darkmode .header-btn.active {
  color: #ffa500;
  border-bottom: 6px solid #ffa500;
}
@media screen and (max-width: 2350px) {
  .search-input-container {
    width: 1000px;
  }
  .resizable-event-container {
    width: 1000px;
  }
}
@media screen and (max-width: 2150px) {
  .search-input-container {
    width: 40dvw;
  }
}
app-event-view-search {
  width: 100%;
}
.info-btn {
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.264));
  height: 32px;
  width: 32px;
  border-radius: 50%;
}
.info-btn img {
  height: 16px;
  width: auto;
}
.menu-btn {
  background-color: transparent;
  border: none;
}
.menu-btn:hover {
  cursor: pointer;
}
.darkmode .menu-btn {
  color: orange;
}
app-menu-sidebar {
  height: 100dvh;
}
::ng-deep .dropdown-toggle:after {
  display: none;
}
.my-2 {
  margin-top: 0 !important;
}
.dropdown-menu {
  --cui-dropdown-padding-y: 0 !important;
}
.custom-event {
  padding: 8px;
  border-left: 4px solid #dc3545;
  background: #fff5f5;
  border-radius: 6px;
}
.event-title {
  font-weight: 600;
  font-size: 14px;
}
.event-time {
  font-size: 12px;
  color: #666;
}
/*# sourceMappingURL=header.component.css.map */
